namespace AgerLMS {
    export enum PaymentLogTypes {
        ThreeDPaymentRequest = 0,
        ThreeDPaymentResponse = 1,
        PaymentRequest = 2,
        PaymentResponse = 3,
        PaymentCancelRequest = 4,
        PaymentCancelResponse = 5,
        PaymentRefundRequest = 6,
        PaymentRefundResponse = 7,
        PaymentQueryRequest = 8,
        PaymentQueryResponse = 9
    }
    Serenity.Decorators.registerEnumType(PaymentLogTypes, 'AgerLMS.PaymentLogTypes');
}
